import { Component } from "@angular/core";

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: "tpm-multi-subscription-news-warning",
  templateUrl: "./multi-subscription-news-waring.component.html",
  styleUrls: ["./multi-subscription-news-waring.component.scss"]
})
export class MultiSubscriptionNewsWarningComponent {}
